// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"720115d1","458":"b6c921ca","658":"84c09573","743":"1b48753a","826":"8dc657e5"}[chunkId] + ".css";
};